import { Injectable } from '@angular/core';
import { throwError, Observable, Subject, BehaviorSubject } from 'rxjs';
import { ApiService } from '@core/http';
import { environment } from '@env';
import { catchError, filter, map, take, takeUntil, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SessionDetailsPatientTimelineService {
  constructor(private apiService: ApiService) {}

  fetchTokenFromBackend(): Promise<string> {
    const url = `${environment.environmentVariables.apiAuthUrl}/embedded/superset/getToken/${environment.environmentVariables.supersetDashboardID}`;
    return this.apiService
      .get<{ token: string }>(url)
      .pipe(
        map((response) => response.token),
        catchError((error) => throwError(() => new Error(error))),
      )
      .toPromise();
  }
}
